module.exports = __webpack_public_path__ + "static/media/Layer.347943dc.png";